import React from "react";

import styled from "@emotion/styled";

import {
  Search as BaseSearch,
  Select as BaseSelect,
  Multiselect,
} from "shared/components/Form";
import { COLORS, TRANSITIONS, MEDIA_QUERIES } from "shared/config/constants";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Container = styled(({ alt, justifyContent, noWrap, ...props }) => (
  <div {...props} />
))((props) => ({
  display: "flex",
  flexWrap: props.noWrap ? "nowrap" : "wrap",
  alignItems: "center",
  justifyContent: props.justifyContent || "flex-start",
  padding: props.padding || "10px 24px",
  backgroundColor: `${COLORS.filterBar.default.background}`,
  borderBottom: `1px solid ${COLORS.borders}`,
  fontSize: "15px",
  ...(props.alt === true && {
    backgroundColor: `${COLORS.filterBar.alt.background}`,
  }),
  ...(props.noBorderBottom && {
    borderBottom: "none",
  }),
  ...(props.noWrap && {
    overflowX: "scroll",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
      height: "6px",
      display: "block",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0, 0, 0, 0.05)",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(0, 0, 0, 0.2)",
      borderRadius: "3px",
      transition: "background 0.2s ease",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.3)",
      },
    },
  }),
  "& > div": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  [MEDIA_QUERIES.w.ltSm]: {
    ...(!props.displayOnMobile && {
      display: "none",
    }),
  },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FilterItem = styled(({ order, noShrink, grow, ...props }) => (
  <div {...props} />
))((props) => ({
  display: "flex",
  alignItems: "center",
  margin: "4px 16px 4px 0",
  flexShrink: 0,
  "&.ant-input-search .ant-input-affix-wrapper": {
    border: "none",
    outline: "none",
  },
  ...(props.order && {
    order: props.order,
  }),
  ...(props.noShrink === true && {
    flexShrink: 0,
  }),
  ...(props.grow === true && {
    flexGrow: 1,
    justifyContent: "flex-end !important",
  }),
}));

const Text = styled("span")({
  lineHeight: 2,
  marginLeft: "5px",
});

const Search = styled(BaseSearch)<{ useDealsListRedesign?: boolean }>`
  ${(props) =>
    props.useDealsListRedesign &&
    `
    .ant-input-affix-wrapper {
      &:focus-within {
        border-color: ${COLORS.input.focus.border} !important;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }
    }
  `}
`;

const Select = styled(BaseSelect)<{ minWidth?: string }>(({ minWidth }) => ({
  minWidth: minWidth || "130px",
}));

const StyledMultiselect = styled(Multiselect)<{ minWidth?: string }>`
  min-width: ${({ minWidth }) => minWidth || "225px"};
  display: block;
`;

const SortOrder = styled("span")({
  "&, path": {
    transition: TRANSITIONS.default,
  },
  "&:hover": {
    "&, path": {
      color: COLORS.sortOrder.hover,
      stroke: COLORS.sortOrder.hover,
    },
  },
});

const DatePickerSpacer = styled("div")({
  margin: "0 7px",
});

export {
  Container,
  FilterItem,
  Text,
  Search,
  Select,
  StyledMultiselect,
  SortOrder,
  DatePickerSpacer,
};
